var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22,
    fill: "white",
    stroke: "#00C500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5131 12C16.7309 12 12 16.7309 12 22.5131C12 28.2954 16.7309 33.0263 22.5131 33.0263C25.4043 33.0263 28.0851 31.8961 29.9775 29.9775L28.0851 28.0851C26.6658 29.5044 24.6946 30.398 22.4869 30.398C18.1239 30.398 14.602 26.8761 14.602 22.5131C14.602 18.1502 18.1239 14.6283 22.4869 14.6283C24.6683 14.6283 26.5607 15.5745 27.98 17.02L25.1151 19.8849H33V12L29.8723 15.1277C27.98 13.2353 25.378 12 22.4869 12H22.5131Z",
    fill: "#00C500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon_refresh.f141e08a8a99011a972919a31cc6e5f3.svg";
export { ForwardRef as ReactComponent };